import React from 'react';
import { motion } from 'framer-motion';
import { WhatsAppIcon } from './WhatsAppIcon';
export const CTASection = () => {
  return <section className="py-16 md:py-24 px-6 text-center max-w-4xl mx-auto flex flex-col items-center justify-center" data-id="element-32">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="font-serif text-5xl md:text-7xl text-brand-charcoal leading-tight mb-12" data-id="element-33">
        Tu próxima cita comienza con un mensaje.
      </motion.h2>

      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} data-id="element-34">
        <a href="https://wa.me/584244582867" target="_blank" rel="noreferrer" className="glass-panel bg-white/30 hover:bg-white/50 px-8 py-5 md:px-12 md:py-6 rounded-full inline-flex items-center gap-4 font-sans text-sm md:text-base font-medium tracking-widest uppercase text-brand-charcoal transition-all duration-300 hover:scale-105 hover:shadow-2xl group" data-id="element-35">
          <WhatsAppIcon className="w-7 h-7 md:w-8 md:h-8 text-brand-charcoal group-hover:scale-110 transition-transform shrink-0" data-id="element-36" />
          → Escríbeme por WhatsApp y aparta tu turno ←
        </a>
      </motion.div>
    </section>;
};